import { Link } from 'react-router-dom';

import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  useOpenSubmissionCount,
  usePendingApplicationCount,
  usePendingRosterApplicationCount,
} from '@/staff/queries';

export function StaffHubPage() {
  const { data: pendingAppCount } = usePendingApplicationCount();
  const { data: openInboxCount } = useOpenSubmissionCount();
  const { data: pendingRosterAppCount } = usePendingRosterApplicationCount();

  return (
    <div className="container mx-auto max-w-4xl px-4 py-8">
      <h1 className="mb-6 text-2xl font-bold">Staff Dashboard</h1>
      <div className="grid gap-4 md:grid-cols-2">
        <Link to="/staff/inbox">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                Inbox
                {openInboxCount && openInboxCount > 0 ? (
                  <Badge variant="destructive">{openInboxCount}</Badge>
                ) : null}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Triage open submissions across all categories.
              </p>
            </CardContent>
          </Card>
        </Link>
        <Link to="/staff/feedback">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>Feedback</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Review player feedback and suggestions.
              </p>
            </CardContent>
          </Card>
        </Link>
        <Link to="/staff/bug-reports">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>Bug Reports</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">Review and triage bug reports.</p>
            </CardContent>
          </Card>
        </Link>
        <Link to="/staff/player-reports">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>Player Reports</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Review reports of problematic player behavior.
              </p>
            </CardContent>
          </Card>
        </Link>
        <Link to="/staff/gm-applications">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>GM Applications</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Review player applications to become GMs.
              </p>
            </CardContent>
          </Card>
        </Link>
        <Link to="/staff/system-errors">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>System Errors</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Triage auto-captured runtime errors with tracebacks and occurrence counts.
              </p>
            </CardContent>
          </Card>
        </Link>
        <Link to="/staff/applications">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                Character Applications
                {pendingAppCount && pendingAppCount > 0 ? (
                  <Badge variant="destructive">{pendingAppCount}</Badge>
                ) : null}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Review player-created character submissions.
              </p>
            </CardContent>
          </Card>
        </Link>
        <Link to="/staff/roster-applications">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                Roster Character Applications
                {pendingRosterAppCount && pendingRosterAppCount > 0 ? (
                  <Badge variant="destructive">{pendingRosterAppCount}</Badge>
                ) : null}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Review applications for existing staff-authored roster characters.
              </p>
            </CardContent>
          </Card>
        </Link>
        <Link to="/staff/invites">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>Account Invites</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Issue, track, and revoke invite-only registration links.
              </p>
            </CardContent>
          </Card>
        </Link>
        <Link to="/staff/missions">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>Mission Studio</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Browse, edit, and publish mission templates; manage the giver library and the
                staff-power assign / copy / flavor-rewrite surfaces.
              </p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/staff/npc-services/roles">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>NPC Services</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Author NPC roles and the service offers they make; mission-giving and permit
                issuance: on the unified offer framework.
              </p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/staff/pantheon">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>Deity Editor</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Author the pantheon: gods, nicknames, feast days, relationships, visibility, and
                each being&apos;s tracking dashboard.
              </p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/staff/missions/givers">
          <Card className="cursor-pointer transition-colors hover:bg-muted/50">
            <CardHeader>
              <CardTitle>Trigger Givers</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Author rooms and objects that hand a player a mission on entry or examine
                (ROOM_TRIGGER / ENVIRONMENTAL_DETAIL).
              </p>
            </CardContent>
          </Card>
        </Link>
      </div>
    </div>
  );
}
